module.exports = __webpack_public_path__ + "img/Creditors-logo.6968a85f.svg";